/**
 * Push plumbing shared by the app's features: the Android push token (set when the system hands it
 * out) and handlers for "a notification was tapped" actions, keyed by the message's `type`.
 */

let pushToken: string | null = null

export function getPushToken(): string | null {
  return pushToken
}

export function setPushToken(token: string | null): void {
  pushToken = token
}

export type PushActionHandler = (data: Record<string, string>) => void

const handlers = new Map<string, Set<PushActionHandler>>()

/** Calls `handler` when a notification of this `type` is tapped. Returns the unsubscribe function. */
export function onPushAction(type: string, handler: PushActionHandler): () => void {
  const set = handlers.get(type) ?? new Set<PushActionHandler>()
  set.add(handler)
  handlers.set(type, set)
  return () => {
    set.delete(handler)
  }
}

/** Passes a tapped notification's data to the handlers registered for its type. */
export function dispatchPushAction(data: Record<string, string> | undefined): void {
  const type = data?.type
  if (!data || !type) return
  handlers.get(type)?.forEach((handler) => handler(data))
}
